export default "__VITE_ASSET__CHgIbfXN__"